import { FETCH_CAROUSEL_ITEMS } from 'src/common/actions/heroCarousel';
import {
  CAROUSEL_MAPVIEW_GUIDEID,
  CAROUSEL_UPSELL_GUIDEID,
} from 'src/common/constants/heroCarousel';
import { LINE_BREAK_INSTRUCTION } from 'src/common/constants/localizations/shared';
import getGuideItemPathname from 'src/common/utils/guideItem/getGuideItemPathname';
import defaultCarouselElements from 'src/data/landing/carouselElements.json';
import { fulfilled, pending, rejected } from './utils/asyncActionNameSuffixes';
import createMappedReducer from './utils/createMappedReducer';

export const heroCarousel = createMappedReducer(
  {},
  {
    [pending(FETCH_CAROUSEL_ITEMS)](state) {
      return {
        ...state,
        isFetching: true,
      };
    },
    [rejected(FETCH_CAROUSEL_ITEMS)](state, action) {
      return {
        ...state,
        carouselItems: defaultCarouselElements,
        loadedTime: action.payload.loadedTime,
        isFetching: false,
      };
    },
    [fulfilled(FETCH_CAROUSEL_ITEMS)](state, action) {
      // we only want a max of 5 items for our carousel
      const children = (action?.payload?.content?.children || []).slice(0, 5);

      const carouselItems = children.map((guideItem) => {
        const guideItemText = guideItem?.title || '';
        const [line1, line2, line3] = guideItemText.split(LINE_BREAK_INSTRUCTION) || [];
        const bgColor = guideItem?.backgroundColor || '';
        const actions = guideItem?.actions || {};
        const imageUrl = guideItem?.image || '';
        let tinyImgUrl = guideItem?.tinyImage;
        let href = getGuideItemPathname(guideItem);
        let isCarouselUpsell = false;

        if (guideItem?.guideId === CAROUSEL_UPSELL_GUIDEID) {
          tinyImgUrl = null;
          isCarouselUpsell = true;
          href = '/subscribe/?vt=su&source=landingpage.carouselUpsell';
        } else if (guideItem?.guideId === CAROUSEL_MAPVIEW_GUIDEID) {
          isCarouselUpsell = false;
          href = '/explorer/?source=landingpage.map';
        }

        return {
          guideItem: actions,
          line1,
          line2,
          line3,
          href,
          bgColor,
          imageUrl,
          tinyImgUrl,
          isCarouselUpsell,
        };
      });

      return {
        ...state,
        carouselItems,
        loadedTime: action.payload.loadedTime,
        isFetching: false,
      };
    },
  },
);
